<script setup>
import { onDeactivated, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import AddAgent from '../settings/agents/AddAgent.vue';

const route = useRoute();
const router = useRouter();
const formKey = ref(0);

onDeactivated(() => {
  formKey.value += 1;
});

const goToUsers = () =>
  router.push({
    name: 'configuracoes_usuarios',
    params: { accountId: route.params.accountId },
  });
</script>

<template>
  <main class="w-full py-2 sm:py-4">
    <AddAgent :key="formKey" standalone @close="goToUsers" />
  </main>
</template>
